import type { StepConfig } from '../../../../technical/wizard/StepConfig.ts';
import type { PortfolioOptimizerInputFields } from '../portfolio/PortfolioOptimizer.validation.ts';
import type { AssetOptimizerInputFields } from '../asset/AssetOptimizer.validation.ts';
import type { AssetGroup } from '../asset/AssetOptimizerWizard.tsx';
import AllocationConstraintsStep from './AllocationConstraintsStep.tsx';
import type { NotVerifiedAssetWithId } from 'components/market/asset/AssetService.tsx';
import type { Portfolio } from '../portfolio/PortfolioOptimizerWizard.tsx';

export const config = ({
  type,
  assetGroups,
  assetIdToClusterToGroup,
  allowAnyConstraints,
  hideExpressConstraintsAs,
  goToNextStep,
  allItems,
}: {
  assetGroups: AssetGroup[];
  assetIdToClusterToGroup: Record<string, Record<string, string>>;
  goToNextStep: () => void;
  allowAnyConstraints?: boolean;
  type: 'asset' | 'portfolio';
  hideExpressConstraintsAs?: boolean;
  allItems: NotVerifiedAssetWithId[] | Portfolio[];
}): StepConfig<AssetOptimizerInputFields | PortfolioOptimizerInputFields> => ({
  label: 'Allocation constraints',
  element: (
    <AllocationConstraintsStep
      goToNextStep={goToNextStep}
      assetGroups={assetGroups}
      assetIdToClusterToGroup={assetIdToClusterToGroup}
      type={type}
      allowAnyConstraints={allowAnyConstraints}
      hideExpressConstraintsAs={hideExpressConstraintsAs}
      allItems={allItems}
    />
  ),
  fields: ['constraintType', 'constraints'],
});
